const formatDate = (date, options) => (new Date(date)).toLocaleDateString('fr-FR', options);

const toDateFrNumeric = (date) => {
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  return formatDate(date, options);
};

function formatEcheance({ echeance }) {
  if (echeance && echeance.includes('/')) {
    return echeance.split('/')
      .map((elem) => elem.padStart(2, '0'))
      .join('/');
  }
  return echeance;
}

const toDateFrLong = (date) => {
  const options = {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  };
  return formatDate(date, options);
};
/**
 ** Return a difference between two dates
 * @param {Date} First date, should be in the past of date 2
 * @param {Date} Second date, should be after date 1
 */
const dateDiffInDays = (a, b) => {
  const MSPERDAY = 1000 * 60 * 60 * 24;
  return Math.floor(Math.abs(b - a) / MSPERDAY);
};

export {
  formatEcheance,
  dateDiffInDays,
  toDateFrNumeric,
  toDateFrLong,
  formatDate,
};
